/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  AutoEndpoint,
  AutoEndpoint$inboundSchema,
  AutoEndpoint$outboundSchema,
} from "./autoendpoint.js";

export type OrgAutoModel = {
  endpoint: AutoEndpoint;
  modelId: string;
  setBy: string;
  setAt: Date;
  resolvable: boolean;
};

/** @internal */
export const OrgAutoModel$inboundSchema: z.ZodType<
  OrgAutoModel,
  z.ZodTypeDef,
  unknown
> = z.object({
  endpoint: AutoEndpoint$inboundSchema,
  model_id: z.string(),
  set_by: z.string(),
  set_at: z.string().datetime({ offset: true }).transform(v => new Date(v)),
  resolvable: z.boolean(),
}).transform((v) => {
  return remap$(v, {
    "model_id": "modelId",
    "set_by": "setBy",
    "set_at": "setAt",
  });
});
/** @internal */
export type OrgAutoModel$Outbound = {
  endpoint: string;
  model_id: string;
  set_by: string;
  set_at: string;
  resolvable: boolean;
};

/** @internal */
export const OrgAutoModel$outboundSchema: z.ZodType<
  OrgAutoModel$Outbound,
  z.ZodTypeDef,
  OrgAutoModel
> = z.object({
  endpoint: AutoEndpoint$outboundSchema,
  modelId: z.string(),
  setBy: z.string(),
  setAt: z.date().transform(v => v.toISOString()),
  resolvable: z.boolean(),
}).transform((v) => {
  return remap$(v, {
    modelId: "model_id",
    setBy: "set_by",
    setAt: "set_at",
  });
});

export function orgAutoModelToJSON(orgAutoModel: OrgAutoModel): string {
  return JSON.stringify(OrgAutoModel$outboundSchema.parse(orgAutoModel));
}
export function orgAutoModelFromJSON(
  jsonString: string,
): SafeParseResult<OrgAutoModel, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => OrgAutoModel$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'OrgAutoModel' from JSON`,
  );
}
